import React from "react";
var __jsx = React.createElement;
import { InfoScreen } from "@/pages/checkout/bnpl/common/components/InfoScreen";
import CopyableField from "./common/CopyableField";
import { useTranslation } from "@i18n";
import { useDhamenContext } from "@/common/Contexts/DhamenContextProvider";
import AcceptedIcon from "@/pages/checkout/dhamen/icons/AcceptedIcon";
import ContactModal from "@/pages/checkout/dhamen/components/common/ContactModal";
import useBoolean from "@hooks/useBoolean";
function AcceptedOffer() {
  var _state$orderInfo2;
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  var _useDhamenContext = useDhamenContext(),
    state = _useDhamenContext.state;
  var contactModal = useBoolean();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InfoScreen, {
    icon: /*#__PURE__*/React.createElement(AcceptedIcon, null),
    title: tShort("dhamen/accepted_offer_title"),
    text: tShort("dhamen/accepted_offer_text"),
    text2: tShort("dhamen/accepted_offer_text2"),
    injectedContent: /*#__PURE__*/React.createElement("div", {
      className: "my-6"
    }, /*#__PURE__*/React.createElement(CopyableField, {
      label: tShort("dhamen/reference_number"),
      value: String(state.orderInfo.financing_details.quote_no)
    })),
    primaryButton: {
      label: tShort("dhamen/go_to_alj_platform"),
      onClick: function onClick() {
        var _state$orderInfo, _state$orderInfo$fina;
        return window.open(state === null || state === void 0 ? void 0 : (_state$orderInfo = state.orderInfo) === null || _state$orderInfo === void 0 ? void 0 : (_state$orderInfo$fina = _state$orderInfo.financing_details) === null || _state$orderInfo$fina === void 0 ? void 0 : _state$orderInfo$fina.url, "_blank");
      }
    },
    secondaryButton: {
      label: tShort("dhamen/contact_request_manager"),
      onClick: contactModal.setTrue
    }
  }), /*#__PURE__*/React.createElement(ContactModal, {
    open: contactModal.value,
    onClose: contactModal.setFalse,
    toggle: contactModal.toggle,
    title: tShort("dhamen/contact_us_via"),
    phoneNumber: state === null || state === void 0 ? void 0 : (_state$orderInfo2 = state.orderInfo) === null || _state$orderInfo2 === void 0 ? void 0 : _state$orderInfo2.order.sales_user.phone_number
  }));
}
export default AcceptedOffer;